import type { ReactNode } from "react";

import { Status } from "@jti/store/slices/loyaltyCoreSlice";

export const USER_POINTS_PLACEHOLDER = "{#userPoints#}";
export const processLoggedTitle = (
  status: Status,
  replaceStringPlaceholder: (str: string, flag: boolean) => string,
  title: ReactNode = ""
): { processedTitle: ReactNode | string; isLoading: boolean } => {
  if (typeof title !== "string") {
    return { processedTitle: "", isLoading: false };
  }

  if (title.includes(USER_POINTS_PLACEHOLDER) && status !== Status.COMPLETED && status !== Status.FAILED) {
    return { processedTitle: "", isLoading: true };
  }

  const processedTitle = replaceStringPlaceholder(title, false);
  return { processedTitle, isLoading: false };
};
